module.exports = __webpack_public_path__ + "img/12.4e6c3f44.webp";